export const MIN_IMAGE_SIZE_BYTES = 1; // Minimum size in bytes
export const MAX_IMAGE_SIZE_BYTES = 2 * 1024 * 1024; // Maximum size in bytes (2MB)